import React, {useEffect} from "react";
import LeftSide from "../../components/live-leap/leftSide";
import RightSide from "../../components/live-leap/rightSide";
import BodyLive from "../../components/live-leap/body";
import {connect} from "react-redux";
import {resultSocket} from "../../redux/actions/resultActions";
import _ from "lodash";
import {withTranslation} from "react-i18next";
import ResultLiveSC from "../../components/live-sc/resultLive";

const LiveSCPage = ({...props}) => {
    const {drawSc, resultSocket, t} = props;
    let data =  drawSc?.data;
    useEffect(() => {
        resultSocket();
    }, [resultSocket]);

    return <div className="container-fluid position-relative live">
        <div className="row pt-0 pb-3">
            <LeftSide/>
            {
                _.isEmpty(data) ? <BodyLive t={t} type="sc"/> : <ResultLiveSC result={data} {...props}/>
            }
            <RightSide/>
        </div>
    </div>
};

const mapStateToProps = state => ({
    resultSc: state.resultSc?.result,
    drawSc: state.resultSc?.draw
});

export default connect(mapStateToProps, {resultSocket})(withTranslation()(LiveSCPage));
